import {
    GetDeliveryPointsByIdLoading,
    GetDeliveryPointsByIdSuccess,
    GetDeliveryPointsByIdReject,
    GetDeliveryPointsByIdRequest
} from "../../actions/home/GetDeliveryPointsById";

export const GetDeliveryPointsById = (formData) => async (dispatch, getState) => {
    dispatch(GetDeliveryPointsByIdLoading());
    try {
        const { data } = await GetDeliveryPointsByIdRequest(formData, getState);
        dispatch(GetDeliveryPointsByIdSuccess(data))
    } catch (error) {
        dispatch(GetDeliveryPointsByIdReject(error))
    }
    return Promise.resolve();
};
export const ClearData = () => async (dispatch, getState) => {
    dispatch(GetDeliveryPointsByIdReject({}))
}
